import { Tabs } from 'antd';
import { useMatch } from 'react-router-dom';

import useTypedNavigate from '../hooks/useTypedNavigate';
import useTypedParams from '../hooks/useTypedParams';
import { JobPostingId } from '../types';
import styles from './OpportunityTabs.module.css';

const OpportunityTabs = () => {
  const { tenant, id } = useTypedParams({ tenant: String, id: JobPostingId });
  const navigate = useTypedNavigate();
  const match = useMatch(':tenant/opportunities/:id/:activeTabKey/*');

  const handleTabChange = (key: string) => {
    switch (key) {
      case 'analysis':
        navigate(
          { pathname: '/:tenant/opportunities/:id/analysis/', params: { tenant, id } },
          { replace: true }
        );
        break;
      case 'manager_dashboard':
        navigate(
          { pathname: '/:tenant/opportunities/:id/manager_dashboard/', params: { tenant, id } },
          { replace: true }
        );
        break;
      case 'details':
        navigate(
          { pathname: '/:tenant/opportunities/:id/details/', params: { tenant, id } },
          { replace: true }
        );
        break;
    }
  };

  return (
    <>
      <Tabs
        activeKey={match?.params?.activeTabKey || 'analysis'}
        onChange={handleTabChange}
        className={styles.customTab}
        items={[
          { key: 'analysis', label: 'Analisar Candidatos' },
          { key: 'manager_dashboard', label: 'Dashboard da vaga' },
          { key: 'details', label: 'Resumo da vaga' },
        ]}
      />
    </>
  );
};

export default OpportunityTabs;
